import { render } from "./outboundTracking.vue?vue&type=template&id=b2cfdb22&scoped=true"
import script from "./outboundTracking.vue?vue&type=script&lang=js"
export * from "./outboundTracking.vue?vue&type=script&lang=js"

import "./outboundTracking.vue?vue&type=style&index=0&id=b2cfdb22&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2cfdb22"]])

export default __exports__